import { render, staticRenderFns } from "./DatepickerComponent.vue?vue&type=template&id=1c819778&scoped=true&"
import script from "./DatepickerComponent.vue?vue&type=script&lang=js&"
export * from "./DatepickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./DatepickerComponent.vue?vue&type=style&index=0&id=1c819778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c819778",
  null
  
)

export default component.exports